export { default as RespImage } from './resp-image';
export { RespImage as default } from './resp-image';
export type {
    RespImageProps,
    SrcsetCandidate,
    ArtDirectionVariant,
} from './resp-image.types';
